import { Paper, Typography, Box, Chip } from '@mui/material';
import { tokens } from '../../../theme/theme';
import { severityChipSx, severityLabel, formatClock } from '../../../utils/severity';

export default function LiveAttackFeed({ feed }) {
  if (!feed?.length) return null;
  return (
    <Paper sx={{ p: 2.4, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>
          Live Attack Feed
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
          <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: tokens.severity.low, boxShadow: `0 0 6px ${tokens.severity.low}` }} />
          <Typography variant="caption" sx={{ color: tokens.text.muted }}>streaming</Typography>
        </Box>
      </Box>
      <Box sx={{ overflowY: 'auto', maxHeight: 340, pr: 0.5 }}>
        {feed.slice(0, 15).map((evt) => (
          <Box
            key={evt.id}
            sx={{
              display: 'flex', alignItems: 'center', gap: 1.2, py: 0.9,
              borderBottom: `1px solid ${tokens.border}`
            }}
          >
            <Typography sx={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '0.7rem', color: tokens.text.muted, width: 60, flexShrink: 0 }}>
              {formatClock(evt.timestamp)}
            </Typography>
            <Chip label={severityLabel(evt.severity)} size="small" sx={{ ...severityChipSx(evt.severity), width: 70, flexShrink: 0 }} />
            <Typography sx={{ fontSize: '0.8rem', color: tokens.text.primary, flex: 1, minWidth: 0 }} noWrap>
              {evt.type}
            </Typography>
            <Typography sx={{ fontFamily: '"JetBrains Mono", monospace', fontSize: '0.72rem', color: tokens.text.secondary, flexShrink: 0 }}>
              {evt.sourceIp}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
